module.exports = __webpack_public_path__ + "static/media/avatar.aef366fe.png";